import React from 'react';
import { Edit3, Trash2, Power } from 'lucide-react';
import { BookingAvailabilityResponseDto, DayOfWeekEnum, DAY_OF_WEEK_LABELS } from '../../types/booking';

const DAYS: DayOfWeekEnum[] = [
  DayOfWeekEnum.Monday,
  DayOfWeekEnum.Tuesday,
  DayOfWeekEnum.Wednesday,
  DayOfWeekEnum.Thursday,
  DayOfWeekEnum.Friday,
  DayOfWeekEnum.Saturday,
  DayOfWeekEnum.Sunday,
];

interface Props {
  schedules: BookingAvailabilityResponseDto[];
  onEdit?: (schedule: BookingAvailabilityResponseDto) => void;
  onDelete?: (schedule: BookingAvailabilityResponseDto) => void;
  onToggleActive?: (schedule: BookingAvailabilityResponseDto) => void;
}

// Weekly Monday-to-Sunday availability grid.
export default function AvailabilityCalendar({ schedules, onEdit, onDelete, onToggleActive }: Props) {
  const byDay = (day: DayOfWeekEnum) => schedules.filter((s) => s.dayOfWeek === day);

  return (
    <div className="grid grid-cols-1 md:grid-cols-7 gap-3">
      {DAYS.map((day) => {
        const daySchedules = byDay(day);
        return (
          <div key={day} className="bg-white border border-strivre-lightnavy rounded-lg overflow-hidden">
            <div className="bg-strivre-softgrey px-3 py-2 border-b border-strivre-lightnavy">
              <h4 className="text-xs font-bold text-strivre-navy uppercase tracking-wide">{DAY_OF_WEEK_LABELS[day]}</h4>
            </div>
            <div className="p-3 space-y-2 min-h-[100px]">
              {daySchedules.length === 0 && (
                <p className="text-xs text-strivre-mutedtext italic">Unavailable</p>
              )}
              {daySchedules.map((s) => (
                <div key={s.id} className={`rounded-md border p-2 ${s.isAvailable ? 'border-strivre-navy/20 bg-strivre-lightnavy' : 'border-strivre-lightnavy bg-slate-50 opacity-60'}`}>
                  <p className="text-xs font-semibold text-strivre-navy">{s.startTime.slice(0, 5)} - {s.endTime.slice(0, 5)}</p>
                  <div className="flex gap-1 mt-2">
                    <button onClick={() => onEdit?.(s)} className="p-1 text-strivre-navy hover:bg-white rounded" title="Edit"><Edit3 size={12} /></button>
                    <button onClick={() => onToggleActive?.(s)} className="p-1 text-strivre-navy hover:bg-white rounded" title="Toggle Active"><Power size={12} /></button>
                    <button onClick={() => onDelete?.(s)} className="p-1 text-strivre-burgundy hover:bg-white rounded" title="Delete"><Trash2 size={12} /></button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

